// 价格日历中的相关事件

var
    Util = require('../../../common/util.js'),
    // 在给定的日期基础上加上若干天，并格式化成 '2017-10-01' 的字符串返回
    addDays = require('../../util').addDays,
    
    buildMonths = require('./buildMonthHTML'),
    
    comfirmPrice = require('../../../js/ticketOrderConfirm/modules/sendRequest').getInitData,
    
    // 查价模块，然后填充日历
    queryPriceForCalendar = require('./queryPriceForCalendar')

const queryString = require('../../util').queryString
const changeTotalMoney = require('../../../js/ticketOrderConfirm/modules/initActive').ticketTotalMoney
const changeToPage = require('../../../js/ticketOrderConfirm/modules/commonTools.js').changeToPage

// 查询日历价已选择的房型
function getRoomPrice(checkin,checkout) {
    var hotelQueryParams = require('../../../common/hotelCalendarPrice/calendarPrice.js').hotelQueryParams;    // 获取点击时的酒店房型参数
    
    var
        // datesInput = document.querySelector(".s-i-dates-input"),
        roomNum = document.querySelector(".s-i-room-num"),
        adultChildren = document.querySelector(".s-i-adult-children"),
        
        params = {
            checkInDate	   	: Util.formatOne(checkin),
            checkOutDate		   	: checkout ? Util.formatOne(checkout) : Util.addDays(checkin, 1),
            roomNum	   	: $(roomNum).attr('data-value'),
            adultNum	   	: adultChildren ? adultChildren.adultNum : 2,
            childrenNum	   	: adultChildren ? adultChildren.childrenNum : 0,
            childrenAgesStr	: adultChildren ? adultChildren.childrenAgesStr : '',
            hotelId         : hotelQueryParams.hotelId,
            roomId         : hotelQueryParams.roomId,
            supplierId     : hotelQueryParams.supplierId,
            rateType       : hotelQueryParams.rateType
        };

    if(!params.hotelId){
        alert("酒店查价没有带 hotelId 参数！")
        return;
    }

    hotelQueryParams.checkInDate = params.checkInDate;
    hotelQueryParams.checkOutDate = params.checkOutDate;

    // 第一次查价 - 只查落地
    $.post('/hotel/getHotelPriceListInStock.do', params, function(res){
        if(res.returnCode === 1) {
            if(res.data.roomTypeBases){      
                let room = res.data.roomTypeBases[0].roomTypePrices[0];
                if(room.isBook) {   
                    // 如果可以预订,跳转到预订页 (参数1: 房间信息, 参数2: 入住信息)
                    // window.location.href = 'https://www.jl-tour.com/user/bookHotel.do';
                    // goToOrderConfirmPage(room,hotelQueryParams)
                    window.location.href = goToOrderConfirmPage(room,hotelQueryParams) ;
                } else {      // 如果不可以预订,弹窗提示
                    if(room.roomStatus == 3) {
                        alert("有日期为满房，请检查")
                    } else {
                        let bookingTerms = getBookingTerms(room.nightlyPriceList)
                        let html = ``;
                        for (let index = 0; index < bookingTerms.length; index++) {
                            const element = bookingTerms[index];
                            html += `<h4>${element.tip}</h4>`
                        }
                        if(html) {
                            alert(html + "选择时间段中不符合预订条款或房间剩余数量不足");
                        } else {
                            alert("查价数据为空，请检查房间剩余数量和预订条款！")
                        }
                    }
                }
                
            } else {    // 第一次查落地没数据,查实时
                
                // 第二次查价 - 实时
                $.post('/hotel/getHotelPriceRealTime.do', params, function(res){
                    if(res.returnCode === 1) {
                        if(res.data.roomTypeBases){      
                            let room = res.data.roomTypeBases[0].roomTypePrices[0];
                            if(room.isBook) {   
                                // 如果可以预订,跳转到预订页 (参数1: 房间信息, 参数2: 入住信息)
                                // window.location.href = 'https://www.jl-tour.com/user/bookHotel.do';
                                // goToOrderConfirmPage(room,hotelQueryParams)
                                window.location.href = goToOrderConfirmPage(room,hotelQueryParams) ;
                            } else {      // 如果不可以预订,弹窗提示
                                if(room.roomStatus == 3) {
                                    alert("有日期为满房，请检查")
                                } else {
                                    let bookingTerms = getBookingTerms(room.nightlyPriceList)
                                    let html = ``;
                                    for (let index = 0; index < bookingTerms.length; index++) {
                                        const element = bookingTerms[index];
                                        html += `<h4>${element.tip}</h4>`
                                    }
                                    if(html) {
                                        alert(html + "选择时间段中不符合预订条款或房间剩余数量不足");
                                    } else {
                                        alert("查价数据为空，请检查房间剩余数量和预订条款！")
                                    }
                                }
                            }
                            
                        } else {    
                            alert("查价数据为空！")
                        }
                    } else {
                        alert(res.returnMsg);
                    }
                })

            }
        } else {
            alert(res.returnMsg);
        }
    })
}

// 跳转确认订单页面
goToOrderConfirmPage = function (_this,hotelQueryParams) {

    var nightlyPriceList = _this.nightlyPriceList;
    var ifInvoice = nightlyPriceList && nightlyPriceList[0] && nightlyPriceList[0].ifInvoice

    var priceStrs = encodeURIComponent( window.JSON.stringify(_this) );

    var priceStrs_key = "hotelPriceStrs_" + (+new Date());

    var params = [
        'staticInfoId=' 		+ _this.hotelId,
        'hotelId=' 				+ _this.hotelId,
        'supplierId=' 			+ _this.supplierId,
        'roomId=' 				+ _this.roomId,
        'breakFastId=' 			+ _this.breakFastId,
        'paymentType=' 			+ _this.paymentType,
        'rateType=' 			+ _this.rateType,

        'isQueryPrice=true',
        hotelQueryParams.marketingStr,

        'startDate=' 			+ hotelQueryParams.checkInDate,
        'endDate=' 				+ hotelQueryParams.checkOutDate,
        'citytype=' 			+ $.queryingHotelParams.type || '0',
        'adultNum=' 			+ $.queryingHotelParams.adultNum,
        'childrenNum=' 			+ $.queryingHotelParams.childrenNum,
        'childrenAgeStr=' 		+ $.queryingHotelParams.childrenAgesStr,
        'roomNum=' 				+ $.queryingHotelParams.selRoomNum,
        'ch=' 					+ $.queryingHotelParams.type || '0',
        'hotelPriceStrsKey=' 	+ priceStrs_key,
        'isTicket=' 	        + ((!ifInvoice || ifInvoice === 1 || ifInvoice === 3) ? 0 : 1)
    ];

    sessionStorage.setItem(priceStrs_key, priceStrs);

    var url = "/order/orderConfirm.do?" + params.join('&');

    return url;
}

// 初始化价格日历每一天的点击事件
function initCalendarDayClick () {
    $(document).delegate('.cp-td-inner', 'click', function () {
        
        if ($(this).hasClass('disabled') || $(this).hasClass('disabled-checkout')) return

        if ($('.jump-order-btn').length !== 0) {
            
            var 
                _this = $(this),
                thisDayStr = _this.attr('data-day'),
                dayArr = _this.closest('.calendar-price-wrap').find('.cp-td-inner'),
                checkin = $($.grep(dayArr, function (o) { return $(o).hasClass('checkin') })),
                checkout = $($.grep(dayArr, function (o) { return $(o).hasClass('checkout') })),
                checkBetween = $( $.grep( dayArr, function(o){ return $(o).hasClass('between-check') } ) ),
                parent = _this.closest('.calendar-price-wrap').parent(),
                checkinInput = parent.find('.oop-date-input.checkin'),
                thisDayprice = _this.find('.calendar-p-price').text()
                checkinText = _this.find('.check-in-span')
                checkoutText = _this.find('.check-out-span');

            // 如果还没设置入住日期，则...
            if(!checkin.length) { 
                _this.addClass('checkin');    // 入住
                checkinText.removeClass("hidden");  // 入住文字
                // dayArr 每个td元素 thisDayStr 入住日期
                setTmpGray(dayArr,thisDayStr);    // 禁用日期
            } 
            // 如果设置了入住日期而没设置离店日期，则...
            else if(checkin.length && !checkout.length) {     // 已选入住 
                // 点击了入住日期当天
                if( _this.hasClass('checkin') )  {    
                    _this.removeClass('checkin');    // 入住
                    checkinText.addClass("hidden");  // 入住文字
                    removeTmpGray(dayArr);    // 取消禁用日期
                    return;
                }

                // 点击了入住日期前日期
                if( new Date(thisDayStr) < new Date(checkin.attr('data-day')) ) {
                    // 先取消入住
                    checkin.removeClass('checkin');
                    checkin.find(".check-in-span").addClass("hidden"); 
                    removeTmpGray(dayArr);   
                    // 再添加入住
                    _this.addClass('checkin'); 
                    checkinText.removeClass("hidden");
                    setTmpGray(dayArr,thisDayStr);   
                    return;
                }

                // 设置离店
                _this.addClass('checkout');   
                checkoutText.removeClass("hidden");
                setCheckBetween( checkin.attr("data-day"),thisDayStr, dayArr )

                 
                getRoomPrice(checkin.attr('data-day'),thisDayStr);   // 查询日历价已选择的房型

                // 跳转酒店结算页
                // window.location.href(goToOrderConfirmPage($(this)))
                setTimeout(function () {
                    $('.calendar-price-wrap').hide()
                }, 200)

            } else {   // 如果入住日期和离店日期都设置了

            }
            
        } else {
            var
                _this = $(this),
                thisDayStr = _this.attr('data-day'),
                dayArr = _this.closest('.calendar-price-wrap').find('.cp-td-inner'),
                checkin = $($.grep(dayArr, function (o) { return $(o).hasClass('checkin') })),
                parent = _this.closest('.calendar-price-wrap').parent(),
                checkinInput = parent.find('.oop-date-input.checkin'),
                thisDayprice = _this.find('.calendar-p-price').text();
            
            // 如果还没设置入住日期，则...
            if (!checkin.length) {
                _this.addClass('checkin')
                checkinInput.val(thisDayStr).attr('data-v', thisDayStr)
                $('#ticketCalenderPrice').val(addDays(thisDayStr, 0, '-'))
                let aimDom = _this.find('#paramsStore');
                let params = {
                    carType   		: aimDom.attr('data-carType'),
                    isRealName      : aimDom.attr('data-isRealName'),
                    ticketRangeId   : aimDom.attr('data-ticketRangeId'),
                    stockId         : aimDom.attr('data-stockId'),
                    formulaType     : aimDom.attr('data-formulaType'),
                    paymentType     : aimDom.attr('data-paymentType'),
                    priceType    	: aimDom.attr('data-priceType'),
                    ticketType      : aimDom.attr('data-ticketType'),
                    suppName    	: aimDom.attr('data-suppName'),
                    suppId 			: aimDom.attr('data-suppId'),
                    itemId 			: aimDom.attr('data-itemId'),
                    infoId 			: aimDom.attr('data-infoId')
                }
                comfirmPrice(addDays(thisDayStr, 0, '-'), params, function (res) {
                    if (res.returnCode === 1) {
                        $.orderInfo = res
                        $('.t-o-c-price').empty().text(thisDayprice)
                        changeTotalMoney()
                        $('.calendar-price-wrap').hide()
                        $('.chidren-select-wrap').slideToggle('fast')
                    } else if (res.returnCode === -400001) {
                        alert('请先登录', {closeBtn: 0}, function () {
                            //跳转到首页
                            location.href = '/user/bookHotel.do?'
                        })
                    } else {
                        alert(res.errinfo, function () {
                            changeToPage()
                        })
                    }
                    
                })
                
            }
        }
        
    })
}

// 初始化 "上一月" 按钮的点击事件
function initMonthSwitchLeftClick () {
    $(document).delegate('.month-switch-bar.month-left', 'click', function () {
        var
            _this = $(this),
            parent = _this.closest('.calendar-price-wrap'),
            
            // 当前显示的两个月份
            currentMonthArr = parent.find('.cp-one-month-wrap.current'),
            
            // 在当前显示的两个月前面隐藏的月份
            hiddenAhead = $(currentMonthArr[0]).prevAll('.cp-one-month-wrap.hidden');
        
        let $ele = $(".month-right");
        if($ele.hasClass('hidden')) {
            $ele.removeClass('hidden');
        }

        if (hiddenAhead.length < 2) {
            parent.find('.month-left').addClass('hidden')
        }
        
        $(currentMonthArr[currentMonthArr.length - 1]).removeClass('current').addClass('hidden')
        $(currentMonthArr[0]).prev('.cp-one-month-wrap.hidden').removeClass('hidden').addClass('current')
    })
}

// 初始化 "下一月" 按钮的点击事件
function initMonthSwitchRightClick (option) {
    $(document).delegate('.calendar-price-wrap .month-switch-bar.month-right', 'click', function () {
        var
            _this = $(this),
            parent = _this.closest('.calendar-price-wrap'),
            
            // 当前显示的两个月份
            currentMonthArr = parent.find('.cp-one-month-wrap.current'),
            
            // 在当前显示的两个月前面隐藏的月份
            hiddenAhead = $(currentMonthArr[0]).prevAll('.cp-one-month-wrap.hidden'),
            
            // 在当前显示的两个月后面隐藏的月份
            hiddenBehind = $(currentMonthArr[currentMonthArr.length - 1]).nextAll('.cp-one-month-wrap.hidden')
        
        parent.find('.month-left').removeClass('hidden')
        $(currentMonthArr[0]).removeClass('current').addClass('hidden');
        
        var
            lastMonthStr = $(currentMonthArr[currentMonthArr.length - 1]).attr('data-month'),
            cYear = +lastMonthStr.split('/')[0],
            cMonth = +lastMonthStr.split('/')[1],
            newMonthStr = cMonth == 12
                ? (cYear + 1) + '-01'
                : cYear + '-' + (cMonth + 1),
            newMonthHTML = cMonth == 12
                ? buildMonths(cYear + 1, 1)
                : buildMonths(cYear, cMonth + 1);
        var checkin = addDays(newMonthStr, 0, '-');
        let date1 = addDays(new Date(), 0, '-');
        let BetweenDates = getMonthsBetweenDates(new Date(date1), new Date(checkin));
        if(BetweenDates == 6) {
            $(".month-right").addClass('hidden');
        }
        
        // 如果在当前显示的两个月后面还有隐藏的月份，则显示其中一个，否则再动态生成一个月的数据（包括查价）
        if (hiddenBehind.length > 0) {
            $(hiddenBehind[0]).removeClass('hidden').addClass('current')
        } else {
            parent.append(newMonthHTML)

            var
                _this = $(this),
                checkout = addDays(newMonthStr, 30, '-'),
                hotelId = _this.next('.hiddenOrderPrice').attr('data-hotelId'),
                suppId = _this.next('.hiddenOrderPrice').attr('data-suppId'),
                roomType = _this.next('.hiddenOrderPrice').attr('data-roomType'),
                priceType = _this.next('.hiddenOrderPrice').attr('data-priceType'),
                currency = _this.next('.hiddenOrderPrice').attr('data-currency');
                // formulaType = _this.next('.hiddenOrderPrice').attr('data-formulaType')
            
            // 预定参数设置面板
            var orderParam = {
                hotelId: hotelId,
                suppId: suppId,
                roomType: roomType,
                priceType: priceType,
                currency: currency,
                // formulaType: formulaType,
                startDateStr: checkin,
                endDateStr: checkout
            }

            // 查价
            queryPriceForCalendar(orderParam, newMonthStr, option)

        }
    })
}

// 设置入住日期和离店日期之间的日期背景颜色
function setCheckBetween( checkin, checkout, dayArr ){
    checkin  = +new Date( checkin );
    checkout = +new Date( checkout );

    for(var i = 0; i < dayArr.length; i++){
        var o = dayArr[i],
            oTime = +new Date( $(o).attr('data-day') );

        if( checkin <= oTime && oTime <= checkout && !$(o).hasClass('day-grayed') ){
            $(o).addClass('between-check');
        }
    }
}

// 日期临时置灰 
// 1.先判断15天内是否有出现无价或者满房的日期
// 2.当选择了入住日期，则超过入住日期15天之后的日期全部置灰
function setTmpGray(dayArr, checkin) {
    if( dayArr && checkin ){
        
        var lastValidDay = new Date( addDays(checkin, 15, '/') + ' 23:59:59' );   // 第15天日期
        var checkinDate = new Date( checkin );      //当前选择的入住日期

        var hasNoPrice;

        for(var i = 0; i < dayArr.length; i++){
            var _date = new Date( $(dayArr[i]).attr('data-day') );     //  循环的这个月份日期

            if( hasNoPrice ) {
                $(dayArr[i]).addClass('disabled-checkout');
                // 价格也变成灰色
                $(dayArr[i]).find(".calendar-p-price").addClass('calendar-d-price');
                continue;
            }

            // 判断当前选择的日期15天内是否有包含disabled类
            if( _date > checkinDate  && _date < lastValidDay && $(dayArr[i]).hasClass('disabled')){
                $(dayArr[i]).removeClass('disabled');
                // 添加临时取消禁用disabled标识类
                $(dayArr[i]).addClass('temporary-cancel-disabled');
                hasNoPrice = new Date( $(dayArr[i]).attr('data-day') );
            }

            if( lastValidDay < _date ){   // 入住日期15天后的置灰
                $(dayArr[i]).addClass('disabled-checkout');
                // 价格也变成灰色
                $(dayArr[i]).find(".calendar-p-price").addClass('calendar-d-price');
            }

        }
    }
}

// 取消置灰
function removeTmpGray(dayArr) {
    if( dayArr ){
        $(dayArr).removeClass( 'disabled-checkout' );
        $(dayArr).find(".calendar-d-price").removeClass( 'calendar-d-price' );
        $(dayArr).each(function(){
            if( $(this).hasClass('temporary-cancel-disabled') ){
                $(this).removeClass('temporary-cancel-disabled').addClass('disabled');
            }
        });
    }
}

// 获取月份中间隔了多少个月
function getMonthsBetweenDates(date1, date2) {
    var months = (date2.getFullYear() - date1.getFullYear()) * 12;
    months += date2.getMonth() - date1.getMonth();
    return months + 1;
}

// 获取预订条款
getBookingTerms = function(pList){
    var
        dataObj = {},
        clauses = [];

    for (var i = 0; i < pList.length; i++) {
        var reserveShowArr = pList[i].reserveShow.split(/[|;]/);
        for (var j = 0; j < reserveShowArr.length; j++) {
            var o = reserveShowArr[j];
            ~o.indexOf('限住') ? dataObj['限制晚数'] = o :
            ~o.indexOf('提前') ? dataObj['提前预订'] = o :
            ~o.indexOf('至少连住') ? dataObj['至少连住'] = o :
            ~o.indexOf('最大连住') ? dataObj['最大连住'] = o :
            ~o.indexOf('连住') ? dataObj['连住多晚'] = o :
            ~o.indexOf('时间') ? dataObj['限时预订'] = o :
            ~o.indexOf('间数') ? dataObj['限制间数'] = o :
                                dataObj['无预订条款'] = o;
        }
    }

    for(key in dataObj){
        if( key !== '无预订条款' )		clauses.push({name: key, tip: dataObj[key]});
    }

    return clauses;

    // orderClauseTd[0].clauses = clauses;

    // clauses.length === 0 ? orderClauseTd.html('无预订条款').removeClass('hp-order-clause') :
    // clauses.length === 1 ? orderClauseTd.html(clauses[0].name) :
    //                        orderClauseTd.html('复合条款');
},

module.exports = function (option) {
    
    // 初始化价格日历每一天的点击事件
    initCalendarDayClick(option)
    
    // 初始化 "上一月" 按钮的点击事件
    initMonthSwitchLeftClick(option)
    
    // 初始化 "下一月" 按钮的点击事件
    initMonthSwitchRightClick(option)
}



// WEBPACK FOOTER //
// ./src/common/hotelCalendarPrice/modules/calendarEvents.js